import cx from "classnames";
import React, { CSSProperties } from "react";
import styles from "./switch.module.scss";

export interface ISwitchItem<ValueType> {
  name: React.ReactNode;
  value: ValueType;
  width?: number;
  disabled?: boolean;
}

export interface ISwitch<ValueType extends string | undefined | boolean | number | null> {
  items: ISwitchItem<ValueType>[];

  active?: ValueType;
  onChange: (active: ValueType) => void;

  readOnly?: boolean;

  size: "small" | "medium" | "large";

  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const Switch = <ValueType extends string | undefined | boolean | number | null>(props: ISwitch<ValueType>) => {
  return (
    <div
      className={cx(
        styles.switch,
        props.size === "small" && styles.small,
        props.size === "medium" && styles.medium,
        props.size === "large" && styles.large,
        props.className
      )}
      style={props.style}
      id={props.htmlId}
    >
      {props.items.map((it, key) => (
        <button
          key={key}
          className={cx(styles.item, it.value === props.active && styles.active, props.readOnly && styles.readonly)}
          style={(it.width && { width: it.width }) || {}}
          onClick={() => !props.readOnly && props.onChange(it.value)}
          disabled={it.disabled}
          type="button"
        >
          {it.name}
        </button>
      ))}
    </div>
  );
};

Switch.defaultProps = {
  size: "medium",
};
